import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// @ts-nocheck
import xStatus from '@ali/anima-contain-status/lib/x';
import yStatus from '@ali/anima-contain-status/lib/y';
import { parseUserPathExtra } from "../../../funnel";
import { getContentParam, getDomConfig, getDomParam, getDPosDom, getSpmCPos, getSpmDPos, nodeListToArray } from "../../../utils";
import * as helper from "./helper";
import { createIntersection, intersectionExpo } from "./intersection";
import { createMutation, mutationCallback, throttleMutation } from "./mutation";
var EXPO_TYPE = helper.EXPO_TYPE;
var FLUSH_TIMER = 0; // 超时定时器

var eventArray = []; // 仅UEP链路埋点上报数据 auto
var combineEventArray = []; // remoteLog链路或 UEP与remoteLog链路双报: manual、mix
var PAYLOAD_LIMIT_SIZE = 10; // 批量上报的大小限制
var FLUSH_TIMEOUT = 240; // 毫秒数

function oldExpoMethod(expoEl, tracert) {
  if (helper.isNoneDom(expoEl, tracert.expoFixedDom)) {
    return;
  }
  var spmAPos = tracert.spmAPos,
    spmBPos = tracert.spmBPos;
  var spmOptions = helper.getSpmIdAndDom(expoEl, spmAPos, spmBPos);
  // 1. spmId check
  var spmId = spmOptions.spmId,
    dom = spmOptions.dom;
  if (!spmId) {
    return;
  }
  var expoElDs = helper.getExpoDomDs(expoEl, spmId, tracert._instanceId);
  var expoInfo = helper.getExpoInfos(dom, expoElDs, tracert);
  // 2. 宽高为0、曝光宽高无变化、非有效曝光且面积不变
  if (!expoInfo) {
    return;
  }
  var percent = expoInfo.percent,
    expoDirection = expoInfo.expoDirection;
  var status = EXPO_TYPE.START;
  if (percent === 100) {
    status = EXPO_TYPE.WHOLE;
  } else if (percent >= 50) {
    status = EXPO_TYPE.HAFT;
  } else if (percent === 0 && (expoElDs.status & 7) !== 0) {
    // 后一个弥补下为0的判断
    status = EXPO_TYPE.DISAPPEAR;
  }
  // uep 已经曝光过当前位置
  if (!expoDirection && helper.expoSamePosition(status, expoElDs.status)) {
    // 会影响expoDirection的生成, 20% -> 70% -> 30% -> 80%(expoDirection需有值)
    expoElDs.direction = expoInfo.direction;
    return;
  }
  var options = {
    combineType: expoDirection ? 'mix' : 'auto',
    percent: percent,
    expoDirection: expoDirection,
    expoState: status === EXPO_TYPE.DISAPPEAR ? 'end' : 'start',
    uuid: expoElDs.uuid
  };
  tracert._doExpo(tracert, spmId, dom, expoEl, options, function () {
    expoElDs.status = helper.setExpoStatus(status, expoElDs.status);
    expoElDs.direction = expoInfo.direction;
    expoElDs.percent = percent;
  });
}
var autoExpo = {
  _expoTypeHandle: null,
  _exposureKey: '__uepExposureData',
  enableWatchStyle: false,
  // 便易性质使用曝光
  _getYStatus: function _getYStatus(el) {
    return yStatus(el);
  },
  _getXStatus: function _getXStatus(el) {
    return xStatus(el);
  },
  // 放在dom中，避免spm对应多个dom
  _getExpoDomDs: function _getExpoDomDs(el, expoVal) {
    if (!el[this._instanceId]) {
      el[this._instanceId] = {};
    }
    if (!el[this._instanceId][expoVal]) {
      el[this._instanceId][expoVal] = {};
    }
    if (!el[this._instanceId][expoVal][this._exposureKey]) {
      el[this._instanceId][expoVal][this._exposureKey] = {
        percent: 0,
        // 默认方向为-1, 首屏元素默认以up形式展现;
        direction: [-1, -1]
      };
    }
    // return el[this._exposureKey];
    var ds = el[this._instanceId][expoVal][this._exposureKey];
    ds.direction = ds.direction || [-1, -1];
    return ds;
  },
  _setExpoDomDs: function _setExpoDomDs(el, ds, expoVal) {
    if (!el[this._instanceId]) {
      el[this._instanceId] = {};
    }
    if (!el[this._instanceId][expoVal]) {
      el[this._instanceId][expoVal] = {};
    }
    el[this._instanceId][expoVal][this._exposureKey] = ds;
  },
  /**
   *
   * @param {string} expoVal  SPMID
   * @param {Element} dom SPM所在dom
   * @param {Element} expoEl 原始dom
   * @returns
   */
  _doExpo: function _doExpo(tracert, spmId, dom, expoEl, options, callback) {
    if (this.expoOnce) {
      this.expoObj = this.expoObj || {};
      var curExpoInfo = this.expoObj[spmId] || {};
      if (!this.expoObj[spmId]) {
        this.expoObj[spmId] = curExpoInfo;
      }
      var uuid = spmId;
      var _spmId = spmId;
      // 已经曝光
      if (curExpoInfo[uuid] === 1) {
        return;
      } else {
        var _spmId$split, _spmId$split$call, _tracert$spmConfig, _tracert$spmConfig$pa, _tracert$spmConfig$pa2, _spmId2, _spmId2$split, _spmId3;
        curExpoInfo[_uuid] = 1; // 只曝光一次 加入缓存; 1标识有效曝光
        var extra = _objectSpread(_objectSpread({}, parseUserPathExtra("expo_".concat(spmId === null || spmId === void 0 ? void 0 : (_spmId$split = spmId.split) === null || _spmId$split === void 0 ? void 0 : (_spmId$split$call = _spmId$split.call(spmId, '.')) === null || _spmId$split$call === void 0 ? void 0 : _spmId$split$call.pop()))), getDomParam(dom));
        var currentConfig = getDomConfig(dom) || {};
        var contentParams = getContentParam(dom);
        var isSeed = /^c|^d/.test(_spmId);
        _spmId = isSeed ? _spmId : "".concat(tracert === null || tracert === void 0 ? void 0 : tracert.spmAPos, ".").concat(tracert === null || tracert === void 0 ? void 0 : tracert.spmBPos, ".").concat(tracert === null || tracert === void 0 ? void 0 : (_tracert$spmConfig = tracert.spmConfig) === null || _tracert$spmConfig === void 0 ? void 0 : (_tracert$spmConfig$pa = _tracert$spmConfig.pages) === null || _tracert$spmConfig$pa === void 0 ? void 0 : (_tracert$spmConfig$pa2 = _tracert$spmConfig$pa[tracert === null || tracert === void 0 ? void 0 : tracert.currentPage]) === null || _tracert$spmConfig$pa2 === void 0 ? void 0 : _tracert$spmConfig$pa2[(_spmId2 = _spmId) === null || _spmId2 === void 0 ? void 0 : (_spmId2$split = _spmId2.split('.')) === null || _spmId2$split === void 0 ? void 0 : _spmId2$split[2]]);
        if ((_spmId3 = _spmId) !== null && _spmId3 !== void 0 && _spmId3.includes('undefined')) {
          _spmId = spmId;
        }
        var _ref = options || {},
          combineType = _ref.combineType,
          percent = _ref.percent,
          expoState = _ref.expoState,
          _uuid = _ref.uuid;
        // uep模式增加percent参数
        contentParams.percent = percent;
        var expoFinished = this.expo(_spmId, extra, contentParams, _objectSpread({
          combineType: combineType,
          expoState: expoState || 'end',
          event: expoEl,
          uuid: _uuid
        }, currentConfig));
        if (expoFinished === true && typeof callback === 'function') {
          callback();
        }
      }
    }
  },
  flushLogPayLoad: function flushLogPayLoad() {
    var _this = this;
    var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var context = arguments.length > 1 ? arguments[1] : undefined;
    if (!immediately && eventArray.length + combineEventArray.length < PAYLOAD_LIMIT_SIZE) {
      if (!FLUSH_TIMER) {
        // 定期清空埋点缓存
        FLUSH_TIMER = setTimeout(function () {
          FLUSH_TIMER = null;
          _this.flushLogPayLoad(true, context);
        }, FLUSH_TIMEOUT);
      }
      return;
    }
    if (FLUSH_TIMER) {
      clearTimeout(FLUSH_TIMER);
      FLUSH_TIMER = null;
    }
    // 无payload
    if (eventArray.length === 0 && combineEventArray.length === 0) {
      return;
    }

    // copy原来缓存数据
    var payload = {};
    if (eventArray.length) {
      payload.eventArray = [].concat(eventArray);
    }
    if (combineEventArray.length) {
      payload.combineEventArray = [].concat(combineEventArray);
    }
    eventArray.length = 0;
    combineEventArray.length = 0;
  },
  expoCheck: function expoCheck(targetNode) {
    // 一些dom类型如：文本类型，注释等，不需要做检查
    if (!targetNode) {
      // eslint-disable-next-line no-param-reassign
      targetNode = this.container || document;
    }
    if (typeof targetNode.querySelectorAll !== 'function') {
      return;
    }
    var beforeResult = this._runBeforeFns('autoExpo', targetNode);
    if (beforeResult === false) {
      return;
    }
    var expoElementList = nodeListToArray(targetNode.querySelectorAll('[data-aspm-expo]'));
    // 补充自身
    if (typeof targetNode.getAttribute === 'function' && targetNode.getAttribute('data-aspm-expo') !== null) {
      expoElementList.push(targetNode);
    }
    // 扫描所有spm元素
    for (var i = 0; i < expoElementList.length; i++) {
      var expoEl = expoElementList[i];
      if (this.intersectionObserver) {
        // 防止影响spmId生成的属性变更导致监控不生效，toggle一下
        this.intersectionObserver.unobserve(expoEl);
        this.intersectionObserver.observe(expoEl);
      } else {
        oldExpoMethod(expoEl, this);
      }
    }
    // 重要: 清空 缓存标注式埋点
    this.flushLogPayLoad(true, this);
  },
  /** *
   * 曝光入口
   */
  startAutoExpo: function startAutoExpo() {
    var _this2 = this;
    if (typeof this._expoTypeHandle === 'function') {
      this._expoTypeHandle();
    }
    if (this.enableIntersectionObserver) {
      this.intersectionObserver = this.intersectionObserver || createIntersection(intersectionExpo, this);
    }
    if (!this.intersectionObserver) {
      this._expoTypeHandle = this.expoType(function () {
        _this2.expoCheck();
      });
    }
    this.expoCheck();
    this.startMutationObserver(document.querySelector('body'), undefined, this.enableWatchStyle ? ['style'] : []);
    this.call('addSideEffects', this.stopAutoExpo);
  },
  stopAutoExpo: function stopAutoExpo() {
    if (this._expoTypeHandle) {
      this._expoTypeHandle();
    }
    this.destroyMutationObserver();
  },
  _observerCb: function _observerCb() {
    var _this3 = this;
    var mutationList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (mutationList.length === 0) {
      return;
    }
    mutationList.forEach(function (mutation) {
      var parentNode = mutation.target.parentNode;
      var addedNodes = mutation.addedNodes,
        _mutation$removedNode = mutation.removedNodes,
        removedNodes = _mutation$removedNode === void 0 ? [] : _mutation$removedNode,
        _mutation$type = mutation.type,
        type = _mutation$type === void 0 ? '' : _mutation$type;
      switch (type) {
        case 'attributes':
          /* An attribute value changed on the element in
           mutation.target.
           The attribute name is in mutation.attributeName, and
           its previous value is in mutation.oldValue. */
          // body自身没办法处理
          if (parentNode) {
            _this3.expoCheck(parentNode);
          }
          break;
        case 'subtree':
        case 'childList':
          if (addedNodes && addedNodes.length) {
            /* One or more children have been added to and/or removed
             from the tree.
             (See mutation.addedNodes and mutation.removedNodes.) */
            // https://developer.mozilla.org/zh-CN/docs/Web/API/NodeList
            _this3._changeNodes(nodeListToArray(addedNodes).concat(nodeListToArray(removedNodes)));
            // this._removeNodes(removedNodes);
          }

          break;
        default:
          break;
      }
    });
  },
  _changeNodes: function _changeNodes() {
    var _this4 = this;
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    nodes.forEach(function (node) {
      _this4.expoCheck(node.parentNode);
    });
  },
  _mutationObserver: function _mutationObserver(targetNode, attributeFilters) {
    if (!this.mutationObserver) {
      return;
    }
    this.mutationObserver.observe(targetNode, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['data-aspm-click', 'data-aspm-expo', 'data-aspm', 'data-aspm-param'].concat(attributeFilters),
      characterData: true
    });
  },
  /**
   * 监听dom变化，触发曝光上报
   * @param {HTMLElement} targetNode 要监控的dom，默认是body
   * @param {Number} waitMs 等待时间，默认500ms
   * @param {Array<String>} attributeFilters 需要监听的属性名，例如：data-active-index
   * @returns
   */
  startMutationObserver: function startMutationObserver(targetNode) {
    var waitMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var appendAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (this.mutationObserver) {
      console.warn('mutationObserver 已开启，请不要重复调用');
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var tracert = this;
    var callback = throttleMutation(function (records) {
      mutationCallback(records, tracert);
    }, waitMs);
    var mutation = createMutation(callback, targetNode || this.container, appendAttrs);
    if (mutation) {
      this.mutationObserver = mutation;
    }
  },
  stopMutationObserver: function stopMutationObserver() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  },
  destroyMutationObserver: function destroyMutationObserver() {
    if (!this.mutationObserver) {
      return;
    }
    this.stopMutationObserver();
    this.mutationObserver = null;
    delete this.mutationObserver;
  },
  getExpoSpmCPos: function getExpoSpmCPos(el) {
    var result = {
      dom: el,
      spmId: ''
    };
    if (!this.spmAPos || !this.spmBPos) {
      return result;
    }
    var cspm = getSpmCPos(el);
    if (!cspm) {
      return result;
    }
    var spmarr = [this.spmAPos, this.spmBPos, cspm];
    result.spmId = spmarr.join('.');
    return result;
  },
  getExpoSpmDPos: function getExpoSpmDPos(el) {
    var dom = getDPosDom(el);
    var spmDPos = getSpmDPos(dom);
    var result = {
      dom: dom,
      spmId: ''
    };
    if (!this.spmAPos || !this.spmBPos) {
      return result;
    }
    if (dom && spmDPos) {
      var spmIdList = spmDPos.split('.');
      var spmIdListlen = spmIdList.length;
      var hasSpmId = true;
      switch (spmIdListlen) {
        case 1:
          spmIdList.unshift(getSpmCPos(dom));
          break;
        default:
          break;
      }
      var len = 2;
      for (var i = 0; i < len; i++) {
        if (!spmIdList[i]) {
          hasSpmId = false;
          break;
        }
      }
      if (hasSpmId) {
        var spmab = [this.spmAPos, this.spmBPos];
        result.spmId = spmab.concat(spmIdList).join('.');
      }
    }
    return result;
  }
};
export default autoExpo;